import { useParams } from 'react-router'
import { useSuppliersProvider } from '../../Suppliers/providers/SuppliersProvider'

export default () => {
  const { supplierBranchId } = useParams<{ supplierBranchId: string }>()
  const { supplierBranchId: supplierBranchIdState } = useSuppliersProvider()

  return (Number(supplierBranchId) || supplierBranchIdState?.[0]) as number
}
